import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import StepRoutes from "../../../Routes/steps_routes";
import { FcSms, FcTemplate } from "react-icons/fc";
import { useSelector } from "react-redux";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewStructureUtilization = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const user = useSelector((store) => store.login.user);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/structureUtilization/getStructure/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting structure utilization!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcTemplate className="fs-2 me-1" /> View assessment of
                  structure for utilization
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>

            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">Structure Utilization Details</h2>
              </div>

              <div className="card-body">
                {data && (
                  <>
                    {/* Project Info */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Project</label>
                      <div className="w-100 col">
                        {(data?.projectName || "N/A").toUpperCase()}
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Length</label>
                      <div className="w-100 col">{data?.lengthOfStru}m</div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">width</label>
                      <div className="w-100 col">{data?.widthOfStru}m</div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Total length (including hocky area)
                      </label>
                      <div className="w-100 col">{data?.totalenHocky}m</div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Total width (including hocky area)
                      </label>
                      <div className="w-100 col">{data?.totawidHocky}m</div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Side / Center Height
                      </label>
                      <div className="w-100 col">
                        {data?.sideHeight}m / {data?.centerHeight}m
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Number of gutters
                      </label>
                      <div className="w-100 col">{data?.gutterNum}</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Gutters length
                      </label>
                      <div className="w-100 col">{data?.gutterLen}</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        North side hockey to column distance (in meters)
                      </label>
                      <div className="w-100 col">{data?.northSideHock}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        South side hockey to column distance (in meters)
                      </label>
                      <div className="w-100 col">{data?.southSideHock}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        East side hockey to column distance (in meters)
                      </label>
                      <div className="w-100 col">{data?.eastSideHock}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        West side hockey to column distance (in meters)
                      </label>
                      <div className="w-100 col">{data?.westSideHock}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Hockey to column join counts
                      </label>
                      <div className="w-100 col">{data?.hockeyToColoumnCount}</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Length of the entry cabin
                      </label>
                      <div className="w-100 col">{data?.lengthOfEntryCabin}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Width of the entry cabin
                      </label>
                      <div className="w-100 col">{data?.widthOfEntryCabin}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Height of the entry cabin
                      </label>
                      <div className="w-100 col">{data?.heightOfEntryCabin}m</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Entry cabin direction
                      </label>
                      <div className="w-100 col">{data?.entryCabinDirection}</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Number of doors to entry cabin
                      </label>
                      <div className="w-100 col">{data?.numOfDoorsEntryCabin}</div>
                    </div>

                    {/* Notes */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Notes</label>
                      <div className="w-100 col">
                        {data?.notes
                          ? data.notes
                              .trim()
                              .split("\n")
                              .map((line, i) => (
                                <span key={i}>
                                  {line}
                                  {i !== data.notes.split("\n").length - 1 && (
                                    <br />
                                  )}
                                </span>
                              ))
                          : "N/A"}
                      </div>
                    </div>

                    {/* Big Column & Side Column Images */}
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Big Column / Side Column
                      </label>
                      <div className="w-100 col d-flex gap-3 flex-wrap">
                        {data?.bigColImg && (
                          <img
                            style={{ height: "300px", width: "450px" }}
                            src={data.bigColImg}
                            alt="Big Column"
                          />
                        )}
                        {data?.sideColImg && (
                          <img
                            style={{ height: "300px", width: "450px" }}
                            src={data.sideColImg}
                            alt="Side Column"
                          />
                        )}
                      </div>
                    </div>

                    <hr />
                    <h1>Side Footers</h1>
                    <hr></hr>
                    <div className="row">
                      {["East", "West", "North", "South"].map((dir) => (
                        <div className="col-md-6 mb-3" key={dir}>
                          <div className="card shadow-sm h-100">
                            <div className="card-body text-center">
                              <h2>Direction: {dir}</h2>
                              <p>
                                <b className="fs-2">
                                  Side footer apron status :{" "}
                                </b>{" "}
                                <span className="fs-2">
                                  {data[`sideFooterApronStatus${dir}`] || "N/A"}
                                </span>
                              </p>
                              {data[`sideFooterApronStatusImg${dir}`] && (
                                <LazyImageComponent
                                  width="100%"
                                  src={data[`sideFooterApronStatusImg${dir}`]}
                                  alt={`${dir} Footer`}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <hr />
                    <h1>Insectnet</h1>
                    <hr></hr>
                    <div className="row">
                      {["East", "West", "North", "South"].map((dir) => (
                        <div className="col-md-6 mb-3" key={dir}>
                          <div className="card shadow-sm h-100">
                            <div className="card-body text-center">
                              <h2>Direction: {dir}</h2>
                              <p>
                                <b className="fs-2">Insectnet Status : </b>{" "}
                                <span className="fs-2">
                                  {data[`sideinsectNetApronStatus${dir}`] ||
                                    "N/A"}
                                </span>
                              </p>
                              {data[`sideinsectNetApronStatusImg${dir}`] && (
                                <LazyImageComponent
                                  width="100%"
                                  src={
                                    data[`sideinsectNetApronStatusImg${dir}`]
                                  }
                                  alt={`${dir} Insect Net`}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <hr />
                    <h1>Polyfilm</h1>
                    <hr></hr>
                    <div className="row">
                      {["East", "West", "North", "South"].map((dir) => (
                        <div className="col-md-6 mb-3" key={dir}>
                          <div className="card shadow-sm h-100">
                            <div className="card-body text-center">
                              <h2>Direction: {dir}</h2>
                              <p>
                                <b className="fs-2">Polyfilm status : </b>{" "}
                                <span className="fs-2">
                                  {data[`sidePolyfieldApronStatus${dir}`] ||
                                    "N/A"}
                                </span>
                              </p>
                              {data[`sidePolyfieldApronImg${dir}`] && (
                                <LazyImageComponent
                                  width="100%"
                                  src={data[`sidePolyfieldApronImg${dir}`]}
                                  alt={`${dir} Footer`}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <hr />
                    <h2>Other Components</h2>
                    <hr></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Secondary Shadow Status
                      </label>
                      <div className="w-100 col">
                        <p className="fs-3">
                          {data.secoundaryShadowNet || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Secondary Shadow Net
                      </label>
                      <div className="w-100 col">
                        {/* <p className="fs-2">{data.secoundaryShadowNet || "N/A"}</p> */}

                        {data.secoundaryShadowNetImg && (
                          <LazyImageComponent
                            width="300px"
                            src={data.secoundaryShadowNetImg}
                            alt="Secondary Shadow Net"
                          />
                        )}
                      </div>
                    </div>

                    <hr></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Top Polyfilm Status
                      </label>
                      <div className="w-100 col">
                        <span className="fs-3">
                          {data.docpolyfilmStatus || "N/A"}
                        </span>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Top Polyfilm
                      </label>
                      <div className="w-100 col">
                        {/* {data.docpolyfilmStatus || "N/A"} */}
                        {data.docpolyfilmImg && (
                          <LazyImageComponent
                            width="300px"
                            src={data.docpolyfilmImg}
                            alt="Doc Polyfilm"
                          />
                        )}
                      </div>
                    </div>

                    <hr></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Universal Join
                      </label>
                      <div className="w-100 col">
                        {data.universalJoin ? (
                          <LazyImageComponent
                            width="300px"
                            src={data.universalJoin}
                            alt="Universal Join"
                          />
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                    <hr></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Secoundary Shadenet pully & rope
                      </label>
                      <div className="w-100 col">
                        {data.secoundaryShadenet ? (
                          <LazyImageComponent
                            width="300px"
                            src={data.secoundaryShadenet}
                            alt="Secoundary Shadenet Join"
                          />
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="card-footer">
                <div className="btn-list justify-content-end">
                  <SimpleButton
                    buttonText="Edit Structure Utilization"
                    href={`/edit-structure-utilization/${id}`}
                  />

                  <SimpleButton buttonText="Cancel" type="secondary" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewStructureUtilization;
